import { del, get, post, postFormData, postFormUrlEncoded, postNoBody } from "../../../common/apis/apiClient";
import { API_ENDPOINT } from "../constants/apiEndpoint";

// --- re.disco.www 알림 설정 API (세션 기반, 기존 Django 엔드포인트) ---
export async function getNotificationCategories() {
  const res = await fetch("/common/get_noti_category/", { credentials: "same-origin" });
  return res.json();
}

export async function updateNotificationCategory(no, activate) {
  const body = new URLSearchParams({ no, activate });
  const res = await fetch("/common/update_noti_category/", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body,
  });
  return res.json();
}

// --- 채팅 알림 설정 (유저 단위) ---
export async function getChatDeviceSetting() {
  const res = await fetch("/common/get_chat_device_setting/", { credentials: "same-origin" });
  return res.json();
}

export async function saveChatDeviceSetting(settings) {
  const body = new URLSearchParams({
    chat_noti_enabled: settings.chat_noti_enabled ?? 1,
    dnd_enabled: settings.dnd_enabled ?? 0,
    dnd_from: settings.dnd_from ?? '22:00',
    dnd_to: settings.dnd_to ?? '08:00',
  });
  const res = await fetch("/common/save_chat_device_setting/", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body,
  });
  return res.json();
}

export function getChatRooms() {
  return get(API_ENDPOINT.CHAT_ROOMS);
}

export function createChatRoom(data) {
  return post(API_ENDPOINT.CHAT_ROOM_CREATE, data);
}

export function leaveChatRoom(roomId) {
  return postNoBody(`${API_ENDPOINT.CHAT_ROOMS}/${encodeURIComponent(roomId)}/leave`);
}

export function getChatBlockUsers() {
  return get(API_ENDPOINT.CHAT_BLOCK_USERS);
}

export function blockUser(userId) {
  return post(`${API_ENDPOINT.USER_BASE}/${encodeURIComponent(userId)}/block`, {});
}

export function unblockUser(userId) {
  return del(`${API_ENDPOINT.USER_BASE}/${encodeURIComponent(userId)}/block`);
}

export function getUserBlockStatus(userId) {
  return get(`${API_ENDPOINT.USER_BASE}/${encodeURIComponent(userId)}/block`);
}

export function uploadChatFile(file, roomId) {
  const form = new FormData();
  form.append("file", file);
  form.append("room_id", roomId);
  return postFormData(API_ENDPOINT.FILE_UPLOAD, form);
}

export async function reportUser(reporterEmail, reportedUser, room) {
  if (!reporterEmail) throw new Error("신고자 이메일이 없습니다.");

  const reportedName = reportedUser?.name ?? reportedUser?.userId ?? "알 수 없음";
  const reportedId = reportedUser?.userId ?? "알 수 없음";
  const roomId = room?.id ?? "알 수 없음";

  const res = await postFormUrlEncoded(API_ENDPOINT.MAIL_CONTACT, {
    contact_email: reporterEmail,
    email_title: `[신고하기] ${reportedName}`,
    contact_message: `신고 대상: ${reportedName} (ID: ${reportedId})\n채팅방 ID: ${roomId}`,
    email_content_for_disco: JSON.stringify({
      reporterUuid: window.loggedInUser?.uuid,
      reporterEmail,
      reportedUserId: reportedId,
      reportedUserName: reportedName,
      roomId,
    }),
  });
  if (res.state !== "Success") throw new Error(res.message ?? "신고 요청에 실패했습니다.");
  return res;
}

/** uuid 배열로 유저 정보 일괄 조회. 응답 objects 배열 반환 */
export async function getUserInfoByUuids(uuids) {
  if (!uuids?.length) return [];
  try {
    const res = await postFormUrlEncoded(`${API_ENDPOINT.USER_INFO}/`, {
      uuids: uuids.join(","),
    });
    return res.status === "success" ? (res.objects ?? []) : [];
  } catch {
    return [];
  }
}

export async function getPropertyBySuid(suid) {
  if (!suid) return null;
  try {
    const res = await postFormUrlEncoded(API_ENDPOINT.SALE_INFO, { uuid: suid });
    const item = Array.isArray(res?.objects) ? res.objects[0] : null;
    if (!item) return null;
    return item;
  } catch {
    return null;
  }
}

export { downloadChatFile } from "../utils/chatFileDownload";
